// extracted by mini-css-extract-plugin
export default {"im-modal":"im-modal--aGT1E","close-box":"close-box--VaiNY","icon":"icon--a08iX"};